exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mat-dialog-title .closebtn {\r\n    font-size: 28px;\r\n    border: none !important;\r\n    position: absolute;\r\n    top: 15px;\r\n    right: 24px;\r\n    width: 18px;\r\n    height: 18px;\r\n    line-height: 16px;\r\n    text-align: center;\r\n    background-color: none !important;\r\n    color: white;\r\n    cursor: pointer;\r\n}\r\n\r\n.popup-title {\r\n    color:white !important;\r\n    padding-left: 10px;\r\n}\r\n\r\n.mat-divider {\r\n    border-top-color: #808080;\r\n}\r\n\r\n.mat-dialog-title{\r\n    padding: 0 !important;\r\n}\r\n\r\n::ng-deep .mat-dialog-container {\r\n    width: 58rem !important;\r\n    /*height: 38rem !important;*/\r\n    height: auto !important;\r\n    /*border: 4px solid var(--font-and-label);*/\r\n    border: solid 3px var(--font-and-label);\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/shared/common/pdfmessage.component.css
// module id = ../../../../../client/app/shared/common/pdfmessage.component.css
// module chunks = main